import { useAccount } from "@qw/auth";
import { type MarketingPlanBankanColumn, useBankanMarketingPlanColumnQuery } from "@qw/graphql";
import { groupBy } from "lodash";
import { weekWindow } from "@/helpers";
import { BankanCardOpportunities } from "./bankan-card-opportunities";
import { BankanGrid } from "./bankan-grid";

export const BankanOpportunities = ({ column }: { column: MarketingPlanBankanColumn }) => {
  const { user } = useAccount();

  const { data } = useBankanMarketingPlanColumnQuery({
    variables: {
      input: {
        brokerId: user.id,
        column,
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const now = Date.now();
  const insured = data?.bankanMarketingPlanColumn?.groupedMarketingPlans || [];

  if (insured.length === 0) {
    return null;
  }

  const groups = groupBy(insured, ({ marketingPlans: { 0: first } }) =>
    weekWindow(new Date(first.desiredEffectiveDate).getTime() - now)
  );

  return (
    <>
      {Object.keys(groups).map((group) => (
        <BankanGrid key={group} count={groups[group].length} label={group}>
          {groups[group].map(({ insured, marketingPlans }) => (
            <BankanCardOpportunities key={insured.id} insured={insured} opportunities={marketingPlans} />
          ))}
        </BankanGrid>
      ))}
    </>
  );
};
